// extracted by mini-css-extract-plugin
export default {"lazySpinner":"LazySpinner_lazySpinner__ZiZJW"};